import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "8b9ce65f-23c6-4822-a8e6-7c547c791f59", content: "Class A", options: {} },
  { id: "a3768307-ed8d-491a-b12d-17b40150c4d9", content: "Class D", options: {} },
  { id: "19fe400c-5d90-4511-b2a6-9ab036ce3577", content: "Class C", options: {} },
  { id: "29177f0e-3e1e-4f18-b022-d370e9ef4bb1", content: "Class F", options: {} },
];

export const task: Task = {
  id: "66962a5e-fc19-4059-b75b-c1a7d399674b",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["8b9ce65f-23c6-4822-a8e6-7c547c791f59"],
};
